import { useMutation } from "@tanstack/react-query";
import { updateSevenRoomsPullSettings } from "../../api/bSevenroomsApi";

export const useUpdateSevenRoomsPullSettings = () => {
  return useMutation({
    mutationKey: ["update-sevenrooms-pull-settings"],
    mutationFn: (data) => updateSevenRoomsPullSettings(data),
    onError: (error) => {
      console.error("SevenRooms pull settings error:", error.response || error);
    },
  });
};
